import { Injectable } from "@angular/core";

export interface WorkSpace {

  id:string;
  name:string;
  vatNumber?:string;
  image:string;
  isOrganisationWorkSpace:boolean;
  active:boolean;
  selected:boolean;
  premium?:boolean;
  role:"admin"|"manager";
}



@Injectable({
  providedIn: 'root'
})

export class WorkSpaceAdapter {
  
  adapt(org: any, active:boolean, selected:boolean): WorkSpace {
    return  { 
      id:org.id, name: 
      org.name, 
      vatNumber:org.vatNumber??'', 
      image: org.image, 
      isOrganisationWorkSpace:true, 
      active: active, 
      selected: selected, 
      premium:org.isPremium, 
      role:org.admin?'admin':'manager' 
    } as WorkSpace
  }  }

  
